import { render, staticRenderFns } from "./leftDrawer2_bis.vue?vue&type=template&id=59b893bb&scoped=true"
import script from "./leftDrawer2_bis.vue?vue&type=script&lang=js"
export * from "./leftDrawer2_bis.vue?vue&type=script&lang=js"
import style0 from "./leftDrawer2_bis.vue?vue&type=style&index=0&id=59b893bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b893bb",
  null
  
)

export default component.exports